import { render, staticRenderFns } from "./Mouth1.vue?vue&type=template&id=2cb8c5c2&"
import script from "./Mouth1.vue?vue&type=script&lang=js&"
export * from "./Mouth1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports